var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 64,
    viewBox: "0 0 71 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1876_5762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5718 59.2525C30.3938 57.0394 32.9098 56.8992 34.9848 57.1295C38.3529 57.51 39.235 62.1065 36.2779 63.5586C34.7943 64.2896 31.3762 64.1894 30.1532 62.8676C29.9227 62.6172 29.622 61.8261 29.5718 61.7961C29.4415 61.716 27.0859 61.6659 26.5546 61.5858C17.7235 60.2439 11.5086 52.7834 11.0375 43.991C10.7167 37.9626 10.7167 29.9813 11.0375 23.9529C12.1301 3.34388 35.7767 -7.74171 51.6347 6.23795C62.1498 15.511 59.704 27.3276 59.9045 39.9854C59.5937 41.4074 57.9498 41.4875 57.4285 40.1556C57.0276 28.6695 59.8142 17.1032 50.4719 8.38096C36.9094 -4.26683 14.6561 4.98619 13.5334 23.2719C13.1024 30.2317 13.8642 37.6221 13.5334 44.6219C14.205 52.8835 21.2018 59.5129 29.5718 59.2425V59.2525Z",
    fill: "#1D00C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.609 43.1799C48.2281 43.4203 47.8772 43.5204 47.4161 43.5605C39.7879 44.2515 31.1271 43.0197 23.3886 43.5605C22.1957 43.4003 22.0855 42.9296 22.1456 41.818C22.296 38.8639 24.4411 33.8769 26.2956 31.5636C26.5963 31.1831 28.4908 29.2003 28.7815 29.0801C29.8741 28.6095 30.6159 29.701 31.488 30.1817C33.8136 31.4635 36.901 31.5135 39.2666 30.2918C40.3191 29.7511 41.0509 28.4292 42.354 29.2504C42.755 29.5007 44.0681 30.8827 44.429 31.3133C45.9426 33.0958 47.0954 35.4691 47.8271 37.6822C48.1579 38.6836 49.3207 42.4289 48.609 43.19V43.1799Z",
    fill: "#1D00C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.476 28.9609C39.5229 28.9609 42.8035 25.6835 42.8035 21.6406C42.8035 17.5977 39.5229 14.3203 35.476 14.3203C31.4291 14.3203 28.1484 17.5977 28.1484 21.6406C28.1484 25.6835 31.4291 28.9609 35.476 28.9609Z",
    fill: "#1D00C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54819 24.0742C7.38498 23.8138 9.65041 25.9568 9.89098 28.7407C10.0514 30.6234 10.1215 37.5431 9.63036 39.0853C8.10671 43.9021 0.548615 43.3313 0.0975353 37.6833C-0.0528247 35.7506 -0.143041 28.7808 0.428327 27.2486C1.05984 25.5262 2.69375 24.2444 4.53817 24.0742H4.54819Z",
    fill: "#1D00C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5034 24.0741C68.3302 23.8137 70.6056 25.9668 70.8462 28.7407C71.0467 31.0439 71.0467 35.38 70.8462 37.6932C70.3049 43.922 61.5539 43.892 61.0628 37.6932C60.9024 35.6804 60.8222 28.9109 61.3936 27.2586C61.9649 25.6062 63.679 24.2443 65.5034 24.0841V24.0741Z",
    fill: "#1D00C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1876_5762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSupportIcon);
export default __webpack_public_path__ + "static/media/ContactSupportIcon.7062bf3a9f8d8a9ca0ea7c380c8bc84d.svg";
export { ForwardRef as ReactComponent };